import React, { FC, useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useLocation } from 'react-router-dom'
import { fiatData, cryptoData, stateFiatData, stateCryptoData } from './DetailsTableLists'
import { TableComponent } from '../../../../../../components/Dashboard/Table'
import { useRest } from '../../../../../../components/Context'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    margin: theme.spacing(2, 0, 4, 0),
  },
}))

export const Details: FC = () => {
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  const location = useLocation()

  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})

  const typeOfAsset = useCallback(() => {
    let assetType = ''
    switch (location.pathname) {
      case '/trading/portfolio/fiat':
        assetType = 'fiat'
        break
      case '/trading/portfolio/crypto':
        assetType = 'crypto'
        break
      default:
        assetType = ''
    }
    return assetType
  }, [location.pathname])

  const loadData = useCallback(
    async (page) => {
      let cleanupFunction = false
      setLoading(true)

      rxiosAuth.get(`${fiatData.request}?page=${page}&count=10`).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          setValues(next)
          if (!cleanupFunction) setLoading(false)
        },
        (error) => {
          toast.error(error)
          setLoading(false)
        },
        () => {
          setLoading(false)
        },
      )
      cleanupFunction = true
      // eslint-disable-next-line
    },
    [rxiosAuth],
  )

  useEffect(() => {
    ;(async () => {
      await loadData('1')
    })()
    // eslint-disable-next-line
  }, [])
  return (
    <Grid item xs={12} className={classes.formWrap}>
      <Grid item xs={12} className={classes.container}>
        <Typography variant={'h1'}>Portfolio</Typography>
      </Grid>

      <Grid item xs={12} className={classes.sectionWrap}>
        <TableComponent
          columns={typeOfAsset() === 'fiat' ? fiatData.columns : cryptoData.columns}
          // data={values.items}
          data={typeOfAsset() === 'fiat' ? stateFiatData : stateCryptoData}
          params={values.meta}
          // eslint-disable-next-line
          loadData={(pageNumber: string | number) => loadData(pageNumber)}
          loading={loading}
        />
      </Grid>
    </Grid>
  )
}
